import React, { useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import CardVideoComponent from "../Elementos/CardVideoComponent";
import { format } from "date-fns";
import SmartInput from "../SmartInput";
import CollapseablePerguntaRespostaItemComponent from "./CollapseablePerguntaRespostaItemComponent";
import CollapseableTutorialItemComponent from "./CollapseableTutorialItemComponent";
import PerguntaRespostaItemComponent from "./PerguntaRespostaItemComponent";
import GenericService from "../../services/Generic.service";
import { useAuth } from "../../contexts/AuthContext";
import { DateTimeZoneFixToday } from "../../utils/DateTimeZoneFix";
import { generateTrigam } from "../../utils/trigamUtils";

// import "../styles/Header.css";
// import MenuPortalItem from "../MenuPortalItem";

function HelpdeskMainMenu(props) {
  const { currentUser } = useAuth();

  let LastIndxColor = 0;
  // const [pergunta, setPergunta] = React.useState("");
  const pergunta = React.useRef("");
  const [faqs, setFaqs] = React.useState([]);
  const [tutoriais, setTutoriais] = React.useState([]);
  const [myTickets, setMyTickets] = React.useState([]);
  const [showAllDocs, setShowAllDocs] = React.useState(false);

  useEffect(() => {
    try {
      // retrieveDataFAQ();
      retrieveDataTutoriais();
    } catch (e) {
      //console.log(e);
    }
  }, []);

  // useEffect(() => {
  //   if (currentUser.uid) {
  //     //console.log("currentUser=", currentUser);
  //     // retrieveMyData();
  //   }
  // }, [currentUser.uid]);

  const retrieveDataFAQ = () => {
    if (!currentUser) return;
    GenericService.getAll("helpdeskfaq", "dadosTicket.pergunta", "asc")
      .then((response) => {
        // //console.log(response);
        setFaqs(response);
      })
      .catch((e) => {
        //console.log(e);
      });
  };

  const retrieveDataTutoriais = () => {
    if (!currentUser) return;
    GenericService.getAll("helpdesktutoriais", "dadosTutorial.searchableName", "asc")
      .then((response) => {
        // console.log(response);
        setTutoriais(response);
      })
      .catch((e) => {
        //console.log(e);
      });
  };

  const retrieveMyData = () => {
    if (!currentUser) return;
    GenericService.getFilteredCollection("helpdesk", "vinculo.idPraticante", "==", currentUser.uid, "metadados.creation", "desc")
      .then((response) => {
        //console.log(response);
        if (response) {
          if (response.length >= 2) {
            setMyTickets(response.slice(0, 2));
          } else {
            setMyTickets(response);
          }
        } else setMyTickets(response);
      })
      .catch((e) => {
        //console.log(e);
      });
    // let mydata = retrieveMyAllData();
    // if (mydata.size() >= 2) return mydata.slice(0, 2);
    // else return mydata;
  };

  const retrieveMyAllData = () => {
    if (!currentUser) return;
    GenericService.getFilteredCollection("helpdesk", "vinculo.idPraticante", "==", currentUser.uid, "metadados.creation", "desc")
      .then((response) => {
        //console.log(response);
        setMyTickets(response);
        setShowAllDocs(true);
      })
      .catch((e) => {
        //console.log(e);
        return [];
      });
  };

  const saveData = () => {
    if (!currentUser) return;
    const newData = {
      dadosTicket: {
        pergunta: pergunta.current,
        resposta: "",
        searchableName: pergunta.current.toLowerCase(),
        trigam: generateTrigam(pergunta.current),
      },
      vinculo: {
        idPraticante: currentUser.uid,
        nomePraticante: currentUser.displayName,
        imagemPerfil: currentUser.photoURL,
      },
      metadados: {
        ownerid: currentUser.uid,
        owner: currentUser.displayName,
        creation: DateTimeZoneFixToday(),
        date: DateTimeZoneFixToday(),
        successorId: "",
        version: 0,
        active: true,
      },
    };
    GenericService.create("helpdesk", newData)
      .then((response) => {
        //console.log(response);
        // setDocs(response);
        retrieveMyData();
        // pergunta.current = "";
        document.getElementById("pergunta").value = "";
      })
      .catch((e) => {
        //console.log(e);
      });
  };

  const myBorderColor = () => {
    // let indxColor = Math.floor(Math.random() * 3);
    // while (indxColor === LastIndxColor) {
    //   indxColor = Math.floor(Math.random() * 3);
    // }
    let indxColor = LastIndxColor + 1;
    if (indxColor > 2) indxColor = 0;
    LastIndxColor = indxColor;
    // if (indxColor === undefined) indxColor = 0;
    const colors = ["border-success", "border-primary", "border-warning"];
    // //console.log("indxColor=", indxColor);
    return colors[indxColor];
  };

  const handleInputChange = (event) => {
    //console.log("event.target=", event.target);
    const { id, value } = event.target;
    //console.log("id=", id, " e value=", value);
    pergunta.current = value;
  };

  try {
    if (!currentUser) return <></>;
    else
      return (
        <>
          <div
            className="offcanvas offcanvas-start text-muted fw-light"
            id="offcanvasHelpdeskMainMenu"
            aria-labelledby="offcanvasExampleLabel"
          >
            <div className="offcanvas-header bg-light pt-2 pb-2">
              <div className="d-flex flex-row align-items-center ">
                <img src="/assets/images/CBTKD_simbolo_cor.svg" alt="CBTKD" width="64px" />
                <h5 className="offcanvas-title" id="offcanvasExampleLabel">
                  Centro de Ajuda
                </h5>
              </div>
              <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div className="offcanvas-body">
              <div className="container-fluid">
                <div className="accordion text-align-justify" id="accordionMain">
                  <p className="fw-light" style={{ fontSize: "smaller" }}>
                    Bem vindo a central de ajuda, aqui você encontra as respostas para suas dúvidas mais comuns, vídeos de instrução ou
                    registre suas dúvidas junto ao nosso time de suporte, que irá ajuda-lo o mais breve possível.
                  </p>
                  <div className="accordion-item border-start-0 border-end-0">
                    <h6 className="accordion-header p-0" id="headingOne">
                      <button
                        className="accordion-button ps-0 pe-0 bg-white collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                        style={{ boxShadow: "none" }}
                      >
                        <span className="material-icons-outlined me-2">quiz</span>Perguntas & Respostas
                      </button>
                    </h6>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionMain"
                    >
                      <div className="accordion-body ps-0 pe-0 fw-light" style={{ fontSize: "smaller" }}>
                        <p>Aqui você encontra as respostas para as perguntas mais frequêntes.</p>
                      </div>
                      {faqs &&
                        faqs.map((doc) => (
                          <CollapseablePerguntaRespostaItemComponent
                            id={doc.id}
                            key={doc.id}
                            pergunta={doc.data().dadosTicket.pergunta}
                            resposta={doc.data().dadosTicket.resposta}
                            borderColor={myBorderColor()}
                            parent="collapseOne"
                          />
                        ))}
                    </div>
                  </div>

                  <div className="accordion-item border-start-0 border-end-0">
                    <h2 className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button collapsed ps-0 pe-0 bg-white"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                        style={{ boxShadow: "none" }}
                      >
                        <span className="material-icons-outlined me-2">video_library</span>Tutoriais
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionMain"
                    >
                      <div className="accordion-body ps-0 pe-0 fw-light d-flex flex-column" style={{ fontSize: "smaller" }}>
                        <p>Aqui você encontra vídeos de instrução, que poderá assistir sempre que desejar.</p>
                        {/* <br /> */}
                        {/* {console.log("tutoriais =", tutoriais)} */}
                        {tutoriais &&
                          tutoriais.map((doc) => (
                            // <>
                            <CardVideoComponent
                              id={doc.id}
                              key={doc.id}
                              keyValue={`TutorialExemplo_${doc.id}`}
                              dtPublicacao={format(new Date(), "dd/MM/yyyy")}
                              title={doc.data().dadosTutorial.title}
                              category={"Tutorial"}
                              objectFit="cover"
                              src={
                                doc.data().dadosTutorial
                                  ? `https://www.youtube.com/embed/${doc.data().dadosTutorial.videoUrl.replace("https://www.youtube.com/watch?v=", "").split("?")[0]
                                  }`
                                  : ""
                              }
                              href={doc.data().dadosTutorial.videlUrl ? doc.data().dadosTutorial.videlUrl : ""}
                            />
                            // <br />
                            // </>
                          ))}
                      </div>
                    </div>
                  </div>

                  {/* <div className={`accordion-item border-start-0 border-end-0 ${myDocs && myDocs.length > 0 ? "" : "collapsed"}`}> */}
                  <div className="accordion-item border-start-0 border-end-0">
                    <h2 className="accordion-header" id="headingThree">
                      <button
                        className="accordion-button collapsed ps-0 pe-0 bg-white"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                        style={{ boxShadow: "none" }}
                      >
                        <span className="material-icons-outlined me-2">contact_support</span>Pergunte ao suporte
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className={`accordion-collapse collapse ${myTickets && myTickets.length > 0 ? "show" : ""}`}
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionMain"
                    >
                      <div className="col-12 col-sm col-md">
                        <SmartInput
                          id="pergunta"
                          ref={pergunta}
                          // value={data.descricao}
                          onChange={handleInputChange}
                          type="textarea"
                          className="form-control form-input middlePosition inputBox multilineText-80"
                          placeholder="Escreva a sua pergunta..."
                          rows={3}
                          cols={1}
                        // required
                        />
                      </div>

                      <div className="d-flex justify-content-end">
                        <button
                          className="btn btn-primary pb-1 w-100"
                          type="button"
                          onClick={saveData}
                        // data-bs-toggle="modal"
                        // data-bs-target={`#${props.modalId}`}
                        >
                          <div className="d-flex align-middle">
                            <span className="ms-1 w-100" style={{ alignItems: "center", fontSize: "0.9em" }}>
                              Perguntar
                            </span>
                          </div>
                        </button>
                      </div>
                      <br />
                      {myTickets && myTickets.length > 0 && (
                        <>
                          <div className="col-12 col-sm col-md">
                            <h6>Últimas feitas</h6>
                            {myTickets &&
                              myTickets.map((doc) => (
                                <PerguntaRespostaItemComponent
                                  id={doc.id}
                                  pergunta={doc.data().dadosTicket.pergunta}
                                  resposta={doc.data().dadosTicket.resposta}
                                // borderColor={myBorderColor()}
                                />
                              ))}
                          </div>
                          <br />
                          <div className={`d-flex justify-content-end ${showAllDocs ? "d-none" : ""}`}>
                            <button
                              className="btn btn-outline-secondary pb-1 w-100"
                              type="button"
                              onClick={retrieveMyAllData}
                            // data-bs-toggle="modal"
                            // data-bs-target={`#${props.modalId}`}
                            >
                              <div className="d-flex align-middle">
                                <span className="ms-1 w-100" style={{ alignItems: "start", fontSize: "0.9em" }}>
                                  Ver todas as perguntas
                                </span>
                                <span className="material-icons-outlined">chevron_right</span>
                              </div>
                            </button>
                          </div>
                        </>
                      )}
                      <br />
                    </div>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            {/* <div className="stick-bootom">
          <hr />
          <div className="d-flex justify-content-center pb-3">
            <button type="button" className="btn btn-primary" onClick={handleCookies} data-bs-dismiss="offcanvas" aria-label="Close">
              Aceito
            </button>
          </div>
        </div> */}
          </div>
        </>
      );
  } catch (e) {
    //console.log(e);
  }
}

export default HelpdeskMainMenu;
